interface IClearLocalStorage {
	type: "employer" | "employee" | "admin"
}

export default function clearLocalStorage(options: IClearLocalStorage) {
	const employeeKeys = Object.keys(localStorage).filter((key) => key.endsWith(options.type))
	employeeKeys.forEach((key) => localStorage.removeItem(key))
}
